import freePoly from "icons/free_game_polygon.png";
import premiumPoly from "icons/premium_game_polygon.png";
import videosPoly from "icons/videos_polygon.png";
// games
import alienEscape from "icons/games/alien_escape.png";
import airWolves from "icons/games/air_wolves.png";
import blastMan from "icons/games/blast_man.png";
import bubbleTouch from "icons/games/bubble_touch.png";
import chopterKid from "icons/games/chopter_kid.png";
import cookingFever from "icons/games/cooking_fever.png";
import crazyCar from "icons/games/crazy_car.png";
import deadStones from "icons/games/dead_stones.png";
import dessertRoad from "icons/games/dessert_road.png";
import doggyvszombie from "icons/games/doggyvszombie.png";
import downhillSki from "icons/games/downhill_ski.png";
import duckShoot from "icons/games/duck_shoot.png";
import escapeTheKiller from "icons/games/escape_the_killer.png";
import findPairs from "icons/games/find_pairs.png";
import fireCircle from "icons/games/fire_circle.png";
import formulaRush from "icons/games/formula_rush.png";

export const gameList = [
  {
    name: "Alien Escape",
    image: alienEscape,
  },
  {
    name: "Air Wolves",
    image: airWolves,
  },
  {
    name: "Blast Man",
    image: blastMan,
  },
  {
    name: "Bubble Touch",
    image: bubbleTouch,
  },
  {
    name: "Chopter Kid",
    image: chopterKid,
  },
  {
    name: "Cooking Fever",
    image: cookingFever,
  },
  {
    name: "Crazy Car",
    image: crazyCar,
  },
  {
    name: "Dead Stones",
    image: deadStones,
  },
  {
    name: "Dessert Road",
    image: dessertRoad,
  },
  {
    name: "Doggy Vs Zombie",
    image: doggyvszombie,
  },
  {
    name: "Downhill Ski",
    image: downhillSki,
  },
  {
    name: "Duck Shoot",
    image: duckShoot,
  },
  {
    name: "Escape The Killer",
    image: escapeTheKiller,
  },
  {
    name: "Find Pairs",
    image: findPairs,
  },
  {
    name: "Fire Circle",
    image: fireCircle,
  },
  {
    name: "Formula Rush",
    image: formulaRush,
  },
];

// export const navList = ["Arcade", "Adventure", "Multiplayer"];

export const navList = [];

export const gameTypesList = [
  {
    name: "Free Games",
    icon: freePoly,
  },
  {
    name: "Premium Games",
    icon: premiumPoly,
  },
  {
    name: "Videos",
    icon: videosPoly,
  },
];
